define('../app/fukit/view/block/product.deactivated.dimmer.view',['require','exports','module','underscore','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var _     = require('underscore'),
      UIKit = require('uikit/uikit');

  var ProductDeactivatedDimmerView = UIKit.Dimmer2.extend({
    options: _.extend({}, UIKit.Dimmer2.prototype.options, {
      inverted: true,
      page: true,
    }),

    content: function() {
      return {
        content: {
          type: UIKit.ComponentsContainerView,
          components: [
            _.extend(
              {
                type: UIKit.Header,
                tagName: 'h2',
                text: 'Product Not Active',
                subText:
                  'The product you are trying to load is not active in your version of Cayuse. Please contact your administrator.',
              },
              Mn._getValue(this.getOption('header'), this)
            ),
            _.extend(
              {
                type: UIKit.ComponentsContainerView,
                spacing: 'uptight',
                childView: UIKit.Button,
                components: [
                  _.extend(
                    {
                      icon: 'refresh',
                      color: 'primary',
                      text: 'Reload',
                      onPress: function() {
                        window.location.reload();
                      },
                    },
                    Mn._getValue(this.getOption('reloadButton'), this)
                  ),
                  {
                    icon: 'call',
                    text: 'Get Help',
                    onPress: function() {
                      window.open('https://support.cayuse.com', '_blank');
                    },
                  },
                ],
              },
              Mn._getValue(this.getOption('actions'), this)
            ),
          ],
        },
      };
    },
  });

  module.exports = ProductDeactivatedDimmerView;
});

